<template>
  <div>
    <NavTop class="navbar">
    </NavTop>
    <!-- 轮播图 -->
    <div class="block">
      <swiper class="swiper" :options="swiperOptions">
        <swiper-slide class="swiper_img" v-for="(slide, index) in slides" :key="index">
          <img style="width: 100%;height: 452px;cursor: pointer" @click.stop="clickRoute('/bannerDetail',slide.id)"
               :src="slide.url" alt="Slide Image">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div ref="targetDiv"></div>
    </div>
    <div class="center">
      <DetailedPage></DetailedPage>
      <div class="right_box">
        <div class="right_box_t">
          <div class="title">{{ bigTitle }}</div>
          <div class="right_link">
            <span class="right_link1">首页</span>
            <span class="right_link1" v-if="houQinTxt">/{{ houQinTxt }}</span>
            <span class="right_link2">/{{ bigTitle }}</span>
          </div>
        </div>
        <!-- 学校简介 -->
        <div v-if="this.$route.params.tabBarId == 10" class="txt">
            <div v-if="scoolJianJie" v-html="scoolJianJie.content"></div>
        </div>
        <!-- 现任领导 -->
        <div v-if="this.$route.params.tabBarId == 11">
          <div class="currentLeader">
            <ul class="currentLeader_ul">
              <li class="currentLeader_li" v-for="(item,index) in ppp" :key="index">
                <i class="currentLeader_i">
                  <span class="currentLeader_span">
                    <img alt>
                  </span>
                </i>
                <div class="currentLeader_text">
                  <h4>
                    <span>{{ item.txt }}</span>
                  </h4>
                  <p>
                    <span>家级课题4项，主持省级科研和教研课题16项。获得教研、科研成果奖励</span>
                  </p>
                  <div>
                    <span>2018.08.02</span>
                    <span>查看更多>></span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div style=" width: 100%;margin-bottom: 15px;display: flex;justify-content: center">
            <el-pagination background layout="prev, pager, next" :total="50"/>
          </div>
        </div>
        <!-- 校园导航 -->
        <div v-if="this.$route.params.tabBarId == 12" style="display: flex;justify-content: center;padding-top: 10px;">
          <Map></Map>
        </div>
        <div v-if="this.$route.params.tabBarId == 45"></div>
        <!-- 部门简介 -->
        <div v-if="this.$route.params.tabBarId == 156">
            <div v-if="dataContent" v-html="dataContent.content"></div>
        </div>
        <!-- 通知公告 -->
        <div v-if="this.$route.params.tabBarId == 157">
          <ul id="tongZhi_ul">
            <li id="tongZhi_li" v-for="(item,index) in dataData" :key="index" @click="goNew(item.id)">
              <div id="tongZhi_liV">
                <span>{{ item.title }}</span>
                <span>{{ extractDate(item.publishTime) }}</span>
              </div>
            </li>
          </ul>
          <div style="width: 100%;display: flex;justify-content: center; margin-top: 20px;  margin-bottom: 80px">
            <el-pagination v-if="total > pageSize" @current-change="clickPage" v-model="pageNum" :page-size="pageSize"
                           background
                           layout="prev, pager, next"
                           :total="total"/>
          </div>
        </div>
        <div v-if="this.$route.params.tabBarId == 548">
          <ul id="tongZhi_ul">
            <li id="tongZhi_li" v-for="(item,index) in dataData" :key="index" @click="goNew(item.id)">
              <div id="tongZhi_liV">
                <span>{{ item.title }}</span>
                <span>{{ extractDate(item.publishTime) }}</span>
              </div>
            </li>
          </ul>
          <div style="width: 100%;display: flex;justify-content: center; margin-top: 20px;  margin-bottom: 80px">
            <el-pagination v-if="total > pageSize" @current-change="clickPage" v-model="pageNum" :page-size="pageSize"
                           background
                           layout="prev, pager, next"
                           :total="total"/>
          </div>
        </div>
        <div v-if="this.$route.params.tabBarId == 549">
          <ul id="tongZhi_ul">
            <li id="tongZhi_li" v-for="(item,index) in dataData" :key="index" @click="goNew(item.id)">
              <div id="tongZhi_liV">
                <span>{{ item.title }}</span>
                <span>{{ extractDate(item.publishTime) }}</span>
              </div>
            </li>
          </ul>
          <div style="width: 100%;display: flex;justify-content: center; margin-top: 20px;  margin-bottom: 80px">
            <el-pagination v-if="total > pageSize" @current-change="clickPage" v-model="pageNum" :page-size="pageSize"
                           background
                           layout="prev, pager, next"
                           :total="total"/>
          </div>
        </div>
        <div v-if="this.$route.params.tabBarId == 592"></div>
      </div>
    </div>

  </div>
</template>
<script>
import NavTop from '../../components/comcomponents/NavTop.vue'
import Map from '../../components/Map/Map.vue'
import home from '../../api/home.js'

export default {
  components: {Map, NavTop},
  data () {
    return {
      // 页数
      pageNum: 1,
      // 每页数量
      pageSize: 20,
      // 总条数
      total: 0,
      swiperOptions: {
        pagination: {el: '.swiper-pagination', clickable: true},
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        loop: true,
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 10000
      },
      slides: [],
      // 大标题
      bigTitle: '',
      two: {
        txt: '党委组织部门'
      },
      // 标记
      biaoji: 10,
      title: '学校简介',
      navItems: [],
      // 现任领导数据
      ppp: [{txt: '1'},
        {txt: '2'},
        {txt: '3'}],
      // 小导航
      houQinTxt: '',
      // 学校简介数据
      scoolJianJie: {},
      scoolContent:[],
      // 部门概况数据
      dataData: [],
      dataContent:[]
    }
  },
  created () {
    // 初始化页码
    // this.pageNum = 1
    this.getTu() // 获取轮播图
    // 获取列表
    if (this.$route.params.tabBarId == 157 || this.$route.params.tabBarId == 548 || this.$route.params.tabBarId == 549) {
      this.getWenZhangListV_Diao(this.$route.params.tabBarId)
    } else {
      this.getWenZhangList(this.$route.params.tabBarId)
    }
    // 小导航
    this.getTabBar(this.$route.params.tabBarId)
  },
  watch: {
    // 观察 $route 对象的变化
    '$route' (to, from) {
      // 获取列表
      if (this.$route.params.tabBarId == 157 || this.$route.params.tabBarId == 548 || this.$route.params.tabBarId == 549) {
        this.getWenZhangListV_Diao(this.$route.params.tabBarId)
      } else {
        this.getWenZhangList(this.$route.params.tabBarId)
      }
      // 这里可以根据 to.params 来获取新的参数
      console.log('New params:', to.params)
      // 小导航
      this.getTabBar(this.$route.params.tabBarId)

      // 根据参数变化执行相应的逻辑
      this.sceoll()
    }
  },
  mounted () {
    setTimeout(() => {
      this.sceoll()
    }, 150)
  },
  methods: {
    // 点击学校新闻产学研用列表
    clickRoute (path, id) {
      this.$router.push(path + '/' + id)
    },
    // 跳转详情
    goNew (id) {
      this.$router.push('/news' + '/' + id)
    },
    // 获取列表
    async getWenZhangList (tabBarId) {
      try {
        const res = await home.getLinkWenZhang({tabBarId})
        // 部门概况
        this.dataData = res.rows
        this.dataContent = this.dataData[0]
        // 学校简介
        this.scoolJianJie = res.rows[0]
        this.scoolContent = this.scoolJianJie[0]
        console.log(this.scoolJianJie, 'lllll')
      } catch (e) {
        console.log(e)
      }
    },
    // 获取列表
    getWenZhangListV_Diao (tabBarId) {
      if (tabBarId == 157 || tabBarId == 548 || tabBarId == 549) {
        this.getWenZhangListV(tabBarId, this.pageNum, this.pageSize)
      }
    },
    async getWenZhangListV (tabBarId, pageNum, pageSize) {
      try {
        const res = await home.getWenZhang({tabBarId, pageNum, pageSize})
        this.dataData = res.rows
        this.total = res.total
      } catch (e) {
        console.log(e)
      }
    },
    // 查看导航栏
    async getTabBar (id) {
      try {
        const res = await home.getTarBarInfo({id})
        this.bigTitle = res.data[0].name
        res.data.forEach(item => {
          if (item.id == 55) {
            this.houQinTxt = item.name
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    // 点击分页
    clickPage (e) {
      this.pageNum = e
      this.getWenZhangListV_Diao(this.$route.params.tabBarId, this.pageNum, this.pageSize)
    },
    // 滑动
    sceoll () {
      const targetLocation = this.$refs.targetDiv
      if (targetLocation) {
        targetLocation.scrollIntoView({behavior: 'smooth'})
      }
    },
    // 截取日期
    extractDate (dateTimeStr) {
      // 使用空格分割日期和时间
      const parts = dateTimeStr.split(' ')
      // 返回日期部分
      return parts[0]
    },
    // 获取首页轮播图
    async getTu () {
      try {
        const res = await home.getBanner({bannerPath: '/'})
        if (res.code === 200) {
          this.slides = res.rows.filter(item => item.tabBarId == 1)
        }
      } catch (e) {
        console.error(e)
      }
    },
    // 跳转链接
    navigateTo (path) {
      this.$router.push(path)
    }
  }

}
</script>

<style lang="less" scoped>
.block {
  margin-bottom: 40px;
}

.center {
  margin: 0 auto;
  width: 1200px !important;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.right_box {
  width: 960px;

  .right_box_t {
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;

    .title {
      width: 100px;
      height: 45px;
      padding: 0 15px;
      line-height: 45px;
      font-size: 20px;
      font-weight: bold;
      color: #444;
      border-bottom: 2px solid #9e070e;
      box-sizing: content-box;
    }

    .right_link {
      font-size: 14px;
      color: #666;

      .right_link1 {
        cursor: pointer;
        font-size: 14px;
        color: #666;

        &:hover {
          text-decoration: underline;
        }
      }

      .right_link2 {
        cursor: text;
        font-size: 14px;
        color: #666;
      }

      .right_link3 {
        font-size: 14px;
        color: #666;
      }
    }
  }
}


.title {
  width: 150px;
  height: 50px;
  padding-top: 10px;
  border-bottom: 3px solid #9e070e;
}


.right_link {
  color: #666;
  font-size: 14px;
}

.txt {
  padding: 40px 0;
  text-indent: 2em;
  line-height: 2em;
  font-size: 20px;
  color: #333;
}
</style>
<!--相关领导样式-->
<style lang="less" scoped>
.currentLeader {
  overflow: hidden;
  margin: 0 auto;
  padding-top: 20px;

  .currentLeader_ul {
    overflow: hidden;
    margin: 0 auto;
  }

  .currentLeader_li {
    margin-top: 0 !important;
    overflow: hidden;
    margin: 30px auto;

    .currentLeader_i {
      overflow: hidden;
      margin: 0 auto;
      display: block;
      width: 350px;
      height: 212px;
      float: left;

      .currentLeader_span {
        color: #337ab7;
        cursor: pointer;

        img {
          overflow: hidden;
          margin: 0 auto;
          display: block;
          width: 350px !important;
          height: 212px !important;
          object-fit: cover;
        }
      }
    }

    .currentLeader_text {
      overflow: hidden;
      margin: 0 auto;
      width: calc(100% - 350px);
      float: left;
      padding-left: 40px;
      cursor: pointer;

      &:hover {
        h4 {
          span {
            color: #3999DC !important;
          }
        }

        p {
          span {
            color: #3999DC;
          }
        }

        div {

          span {
            &:nth-child(2) {
              width: 120px;
              color: #fff;
              background-color: #3999dc;
            }
          }
        }
      }

      h4 {
        overflow: hidden;
        margin: 0 auto 30px;
        font-size: 24px;
        color: #333333;
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;

        span {
          color: #333333;
          cursor: pointer;
        }
      }

      p {
        overflow: hidden;
        margin: 0 auto;
        font-size: 14px;
        color: #999999;
        height: 125px;

        span {
          color: #999999;
          cursor: pointer;
        }
      }

      div {
        overflow: hidden;
        margin: 0 auto;

        span {
          &:nth-child(1) {
            overflow: hidden;
            margin: 0 auto;
            display: block;
            height: 30px;
            line-height: 32px;
            float: left;
            font-size: 14px;
            color: #cccccc;
            padding-left: 20px;
            background: url(../../assets/images/span_ico.png) no-repeat left center;
          }

          &:nth-child(2) {
            width: 100px;
            height: 30px;
            overflow: hidden;
            display: block;
            line-height: 30px;
            float: right;
            font-size: 14px;
            color: #666666;
            padding-left: 20px;
            margin-right: 0;
            transition: .3s;
          }
        }
      }
    }
  }

}
</style>
<!--通知公告-->
<style lang="less" scoped>
#tongZhi_ul {
  width: 960px;
  height: 1000px;

  #tongZhi_li {
    width: 960px;
    height: 50px;

    #tongZhi_liV {
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #444;
      cursor: pointer;

      &:hover {
        color: #FF0029;
      }

      span {
        &:nth-child(1) {
          width: 80%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 16px;
        }

        &:nth-child(2) {
          width: 20%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          text-align: right;
        }
      }
    }
  }
}

ul, li, ol {
  list-style: none;
}
</style>
<style lang="less">
.swiper-pagination {
  /* 未选中时的分页器子弹样式 */

  .swiper-pagination-bullet {
    background-color: #000 !important; /* 未选中时的背景色 */
    width: 8px;
    height: 8px;
    opacity: 0.3 !important;
    //transition: background-color 0.3s, transform 0.3s !important;
  }

  /* 选中时的分页器子弹样式 */

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #8D080E !important; /* 选中时的背景色 */
    width: 15px !important; /* 选中时的宽度 */
    height: 8px;
    opacity: 1 !important;
    border-radius: 5px !important;
  }
}
</style>
<style lang="less">
.el-pager {
  .number:hover {
    background-color: #8D080E !important;
    color: #fff !important;
  }
}

.active {
  background-color: #8D080E !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Profiles/index.vue